var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"below-header advisor-detail"},[_c('advisor-card',{attrs:{"panel":[0],"advisors":_vm.advisors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }